<template>
  <div class="collectiongroup">
    <div class="collectiongroup__filter">
      <div class="collectiongroup__filter__left">
        <div class="createnew">
          <button @click.stop="createNewGroup" class="btn-regular primary" :disabled="disabledCreateNew">
            Create new
            <adx-loading-secondary v-if="createnewIsLoading" slot="loading" />
          </button>
        </div>
        <adx-dropdown-list class="" v-if="!selectedQuickFilter" @selected="selectedVisibility" :list="list" labelButton="All visibility" />
        <adx-dropdown-list class="mobile" @selected="selectedPage" :list="quickfilter" labelButton="Filter" />
      </div>
      <div class="collectiongroup__filter__right" v-if="!selectedQuickFilter">
        <div class="search">
          <i class="adx-ic_search"></i>
          <input class="subhead" type="text" v-model="searchValue" placeholder="Search">
        </div>
      </div>
    </div>
    <div class="collectiongroup__content">
      <div class="collectiongroup__content__listview">
        <div class="collectiongroup__content__listview__public" v-if="selectedQuickFilter">
          <adx-collectiongroup-listpage-view @orderChanged="updatePageData" @dataChanged="updateData" :isLoading="loadingPage" :pageId="selectedQuickFilter" v-if="selectedQuickFilter" :items="itemsPage" :menuList="expansionListPage" />
        </div>
        <div class="collectiongroup__content__listview__private">
          <h3 class="regular-font title">ALL</h3>
          <adx-collectiongroup-list-view :items="items" :isLoading="loading" :menuList="expansionList" @dataChanged="updateData" @orderChanged="updatePageData" />
        </div>
      </div>
      <div class="collectiongroup__content__quickfilter">
        <adx-quickfilter :value.sync="selectedQuickFilter" :list="quickfilter" />
      </div>
    </div>
  </div>
</template>

<script>
import DropdownList from '@/components/Dropdown/ListDropdown'
import CollectionListView from '@/views/Collection/CollectionGroup/ListItem'
import CollectionListPageView from '@/views/Collection/CollectionGroup/ListItemPage'
import QuickFilter from '@/components/QuickFilter'
import LoadingSpinner from '@/components/Loading/Secondary'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import * as validationLib from '@/lib/validation/'
const { helpers } = validationLib

export default {
  name: 'adx-collection-list',
  components: {
    'adx-dropdown-list': DropdownList,
    'adx-collectiongroup-list-view': CollectionListView,
    'adx-collectiongroup-listpage-view': CollectionListPageView,
    'adx-quickfilter': QuickFilter,
    'adx-loading-secondary': LoadingSpinner,
  },
  props: {

  },
  data() {
    return {
      list: [
        {
          'id': 0,
          'label': 'All visibility',
          'value': '',
        },
        {
          'id': 1,
          'label': 'Public',
          'value': 'public'
        },
        {
          'id': 2,
          'label': 'Private',
          'value': 'private'
        }
      ],
      items: [],
      itemsPage: [],
      expansionListPage: [
        {
          "id": 0,
          "name": "Add to page",
          "value": "addpage",
          "items": []
        },
        {
          "id": 1,
          "name": "Remove from page",
          "value": "remove",
        },
        {
          "id": 2,
          "name": "Duplicate",
          "value": "duplicate"
        },
        {
          "id": 3,
          "name": "Delete Group",
          "value": "delete"
        }
      ],
      expansionList: [
        {
          "id": 0,
          "name": "Add to page",
          "value": "addpage",
          "items": []
        },
        {
          "id": 1,
          "name": "Duplicate",
          "value": "duplicate"
        },
        {
          "id": 2,
          "name": "Delete Group",
          "value": "delete"
        }
      ],
      quickfilter: [],
      selectedQuickFilter: 0,
      toggleModal: false,
      loadingPage: false,
      loading: false,
      selectedVisibilityValue: '',
      searchValue: '',
      disabledCreateNew: false,
      createnewIsLoading: false
    }
  },
  computed: {
    getFilterParams: function () {
      const params = {
        visibility: this.selectedVisibilityValue || undefined,
        search: this.searchValue || undefined,
        in_page: this.selectedQuickFilter || undefined
      }
      this.$router.replace({
        query: params
      })
      return params
    },
  },
  watch: {
    selectedQuickFilter: function() {
      this.$nextTick(() => {
        this.loadDataPage()
      });
    },
    searchValue: helpers.debounce(function() {
      this.$nextTick(function () {
        this.loadData()
      })
    }, 500),
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.loadData()
    this.getFilter()
    this.loadExpansion()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    updateData() {
      this.$nextTick(function () {
        this.loadData()
      })
    },
    updatePageData() {
      this.$nextTick(function () {
        this.loadDataPage()
      })
    },
    selectedVisibility(item){
      this.selectedVisibilityValue = item.value
      this.$nextTick(function () {
        this.loadData()
      })
    },
    selectedPage(item){
      this.selectedQuickFilter = item.value
      this.$nextTick(function () {
        this.loadDataPage()
      })
    },
    loadData() {
      (async () => {
        this.items = []
        this.loading = true
        const params = {
          visibility: this.getFilterParams.visibility || undefined,
          search: this.getFilterParams.search || undefined
        }
        const { data } = await api.get(apiV2.collectionGroupList, { params: params, needToken: true })
        this.items = data
        this.loading = false
      })();
    },
    loadDataPage() {
      (async () => {
        this.loadingPage = true
        const params = {
          in_page: this.getFilterParams.in_page
        }
        const { data } = await api.get(apiV2.collectionGroupListOrder, { params: params, needToken: true })
        this.itemsPage = data
        this.loadingPage = false
      })();
    },
    loadExpansion() {
      (async () => {
        const { data } = await api.get(apiV2.pageList, { needToken: true })
        if (data.length > 0) {
          const dataPage = data.map(value => {
            return {
              id: value.id,
              name: value.title
            }
          })
          if (data.length > 0) {
            this.expansionList[0].items = this.expansionList[0].items.concat(dataPage)
            this.expansionListPage[0].items = this.expansionListPage[0].items.concat(dataPage)
          } else {

          }
        }
      })();
    },
    getFilter() {
      (async () => {
        const { data } = await api.get(apiV2.pageList, { needToken: true })
        const filter = data.map(value => {
          return {
            id: value.id,
            label: value.title,
            value: value.id
          }
        })
        filter.unshift({
          id: 0,
          label: `All`,
          value: ``
        })
        this.quickfilter = filter
      })();
    },
    createNewGroup() {
      (async () => {
        this.disabledCreateNew = true
        this.createnewIsLoading = true
        const params = {
          "layout": "FE"
        }
        const { data } = await api.post(apiV2.collectionGroupCreate, params, { needToken: true })
        this.createnewIsLoading = false
        this.disabledCreateNew = false
        this.$router.push({ name: 'collectiongroupeditor', params: { id: data.id } })
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>